<template>
  <section class="search-bar" :class="color">
    <div class="search-bar__logos">
      <section
        class="search-bar__logos__item"
        v-for="item in logos"
        :key="item.logo"
      >
        <figure>
          <img :src="getImage(item.logo)" alt />
        </figure>
        <p v-html="item.text"></p>
      </section>
    </div>
    <form class="search-bar__form" action>
      <div
        class="search-bar__form__group"
        :class="{ 'search-bar__form__group--error': $v.search.category.$error }"
      >
        <select v-model="search.category" @change.prevent="getState()">
          <option value="null" selected disabled hidden>
            Selecione a Especialidade
          </option>
          <option
            :value="category.Codigo"
            v-for="category in categories"
            :key="category.Codigo"
          >
            {{ category.Nome }}
          </option>
        </select>
      </div>
      <div
        class="search-bar__form__group"
        :class="{ 'search-bar__form__group--error': $v.search.state.$error }"
      >
        <select v-model="search.state" @change.prevent="getCity()">
          <option value="null" selected disabled hidden>UF</option>
          <option :value="state" v-for="state in states" :key="state">
            {{ state }}
          </option>
        </select>
      </div>
      <div
        class="search-bar__form__group"
        :class="{ 'search-bar__form__group--error': $v.search.city.$error }"
      >
        <select v-model="search.city">
          <option value="null" selected disabled hidden>
            Selecione sua cidade
          </option>
          <option :value="city" v-for="city in cities" :key="city">
            {{ city }}
          </option>
        </select>
      </div>
      <button type="submit" @click.prevent="handleSubmit()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24.37"
          height="24.282"
          viewBox="0 0 24.37 24.282"
        >
          <path
            id="Shape"
            d="M30.17,28.674l-6.981-6.961A9.777,9.777,0,1,0,21.82,23.1L28.8,30.082ZM9.951,21.067A7.958,7.958,0,0,1,21.194,9.824,7.958,7.958,0,0,1,9.951,21.067Z"
            transform="translate(-5.8 -5.8)"
          />
        </svg>
      </button>
    </form>
    <div class="search-bar__erros" v-if="$v.$error">
      <TheAlert v-if="!$v.search.category.required"
        >Selecione a especialidade que você deseja.</TheAlert
      >
      <TheAlert v-if="!$v.search.state.required"
        >Selecione seu estado.</TheAlert
      >
      <TheAlert v-if="!$v.search.city.required"
        >Selecione a sua cidade.</TheAlert
      >
    </div>
  </section>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { handlePartnerClick } from "@/services/gtm";

export default {
  data() {
    return {
      color: null,
      logos: [
        {
          logo: 'logo-preto-amorsaude',
          text: 'consulta a partir <br />de R$ <strong>26</strong>',
        },
        {
          logo: 'logo-preto-drogasil',
          text:
            'até <strong>35%</strong> em medicamentos',
        },
        {
          logo: 'logo-preto-raia',
          text:
            'até <strong>35%</strong> em medicamentos',
        },
        {
          logo: 'logo-preto-ultragaz',
          text:
            'desconto de 9% no botijão de gás',
        },
        {
          logo: 'logo-preto-refuturiza',
          text: '<strong>R$ 19,99</strong> por mês',
        },
      ],
      search: {
        category: null,
        state: null,
        city: null,
      },
      categories: [],
      states: [],
      cities: [],
    };
  },
  validations: {
    search: {
      category: {
        required,
      },
      state: {
        required,
      },
      city: {
        required,
      },
    },
  },
  methods: {
    ...mapActions(["setPartners"]),
    getImage(image) {
      return require(`./Section/assets/${image}.svg`);
    },
    getCategory() {
      this.$http
        .get(`Site/ListarCategorias`)
        .then((response) => {
          this.categories = response.data.ObjetoRetorno;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getState() {
      this.$http
        .get(
          `Empresa/ListarEstadosPorCategoria?codigoCategoria=${this.search.category}`
        )
        .then((response) => {
          this.states = response.data.ObjetoRetorno;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCity() {
      this.$http
        .get(
          `Empresa/ListarEstadosPorCategoria?codigoCategoria=${this.search.category}&uf=${this.search.state}`
        )
        .then((response) => {
          this.cities = response.data.ObjetoRetorno;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPartners() {
      this.$http
        .get(
          `Empresa/FiltrarParceiros?codigoCategoria=${this.search.category}&uf=${this.search.state}&nomeCidade=${this.search.city}&nome=`,
          {
            headers: {
              "Access-Control-Allow-Headers": "Set-Cookie",
            },
          }
        )
        .then((response) => {
          this.setPartners(response.data.ObjetoRetorno);
          if (this.$route.name === "Home") {
            this.$router.push({ name: "Partners" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        handlePartnerClick();
        this.getPartners();
      }
    },
  },
  components: {
    TheAlert: () => import("@/components/TheAlert.vue"),
  },
  created() {
    this.color = this.$route.name === "Home" ? "black" : "white";
    this.getCategory();
  },
};
</script>

<style lang="scss">
.search-bar {
  &.white {
    color: $color-white;
    form {
      select {
        background: $color-white;
      }
    }
  }
  &.black {
    color: $color-black;
    form {
      select {
        background: #f0f0f0;
        border: 0px none;
      }
    }
  }
  &__logos {
    margin-top: 36px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    justify-content: space-around;
    @include media('>small') {
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 30px;
    }
    @include media(">tablet") {
      grid-gap: 54px;
    }

    &__item {
      text-align: center;

      figure {
        margin: 15px 0;
        height: 40px;
      }

      p {
        font-size: 14px;
        color: $color-lightblue;
        b {
          font-weight: 900;
        }
      }
    }
  }
  &__erros {
    padding: 39px 0;
    @include media(">=tablet") {
      margin: -68px auto 0px;
      max-width: 920px;
    }
  }
  &__form {
    &__group {
      position: relative;
      &::after {
        content: url("../assets/icons/arrow-select.svg");
        position: absolute;
        right: 10%;
        top: 50%;
        transform: translateY(-50%);
      }
      &--error {
        position: relative;
        &::before {
          content: url("../assets/icons/alert.svg");
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          right: 8px;
          transform: translateY(-50%);
          display: block;
        }
        select {
          appearance: none;
          border: 2px solid $color-gray !important;
        }
      }
    }
  }
  form {
    margin-top: 51px;
    padding-bottom: 39px;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 16px;
    justify-content: center;
    position: relative;
    margin-bottom: -1px;

    @include media(">=tablet") {
      margin-bottom: initial;
      padding-bottom: 68px;
      grid-template-columns: 368px 76px 352px auto;
    }

    select {
      border-radius: 10px;
      padding: 18px 12px 18px 20px;
      width: 100%;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: $color-gray;
      outline: none;
      position: relative;
      appearance: none;
      @include media("<=small") {
        border: none;
      }
      @include media(">=tablet") {
        margin-right: 21px;
        &:nth-child(2) {
          width: 80px;
        }
      }
    }

    button {
      border-radius: 10px;
      padding: 15px 20px;
      background: $color-black;
      color: $color-black;
      border: none;
      width: 100%;
      cursor: pointer;
      outline: none;
      bottom: 39px;
      fill: $color-primary;
      transition: 0.3s ease-in-out;
      right: 0px;
      @include media(">=tablet") {
        position: initial;
        bottom: initial;
        right: initial;
        &:hover {
          background: $color-primary;
          fill: $color-black;
        }
      }
    }
  }
}
</style>
